export const getInitials = (name?: string) => {
  if (!name) {
    return ''
  }

  const names = name.replace(' (TMC)', '').split(' ')

  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase()
  }

  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase()
}
